import { createSelector } from '@reduxjs/toolkit';
import { IState } from 'core';
import { IHotColdAnalytics } from './types';

const hotColdAnalyticsStoreSelector = (state: IState) =>
  state.rouletteReducer.hotColdAnalyticsReducer;

export const hotColdAnalyticsSelector = createSelector(
  hotColdAnalyticsStoreSelector,
  (state: IHotColdAnalytics) => state.hotColdAnalytics,
);
